// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';
import ManageInventoryCategory from '@/components/inventory-category/manage';
import { createFileRoute } from '@tanstack/react-router'



function CreateInventoryCategory() {

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace,"/");
        }
    }, [accessStatus]);

    return (
        <div>
            <ManageInventoryCategory isNew={true} accessStatus={accessStatus} />
        </div>
    );
}

export default CreateInventoryCategory;

export const Route = createFileRoute('/_authenticated/inventory-category/create')({ component: CreateInventoryCategory })
